
export default {
  props: {
    product: {
      type: Object,
      default: () => {
        return null
      },
    },
    main: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    margins: {
      type: Boolean,
      default: true,
    },
    quantitySelector: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    '$store.state.shop.products'() {
      this.initProduct()
    },
  },
  mounted() {
    if (this.product) {
      this.initProduct()
    }
  },
  methods: {
    initProduct() {
      const self = this
      const container = document.createElement('div')
      this.$refs.product.appendChild(container)
      window.ui.createComponent('product', {
        id: this.product.id.split('/').pop(),
        node: container,
        moneyFormat:
          this.$store.state.shop.buybutton.currency +
          ' {{amount_no_decimals_with_comma_separator}}',
        options: {
          product: {
            events: {
              afterInit(component) {
                if (self.main && window && window.dataLayer) {
                  const product = component.viewData
                  window.dataLayer.push({
                    event: 'view_item',
                    currency: self.$store.state.shop.buybutton.currency,
                    value: product.variants[0].priceV2.amount,
                    items: [
                      {
                        item_id: product.variants[0].sku,
                        item_name: product.title,
                      },
                    ],
                  })
                }
              },
              addVariantToCart(component) {
                setTimeout(() => {
                  const button = document.getElementById('checkout-button')
                  if (button) {
                    button.addEventListener(
                      'click',
                      function (event) {
                        if (!self.$store.state.consent) {
                          event.preventDefault()
                          event.stopImmediatePropagation()
                          self.$store.commit('setConsentError', true)
                        }
                      },
                      true
                    )
                  }

                  const checkbox = document.getElementById('ageverification')
                  if (checkbox) {
                    checkbox.addEventListener('change', function (event) {
                      if (checkbox.checked) {
                        self.$store.commit('setConsent', true)
                        self.$store.commit('setConsentError', false)
                      } else {
                        self.$store.commit('setConsent', false)
                      }
                    })
                  }
                }, 1000)

                if (window && window.dataLayer) {
                  const product = component.viewData
                  window.dataLayer.push({
                    event: 'add_to_cart',
                    currency: self.$store.state.shop.buybutton.currency,
                    value: product.variants[0].priceV2.amount,
                    items: [
                      {
                        item_id: product.variants[0].sku,
                        item_name: product.title,
                      },
                    ],
                  })
                }
              },
            },
            iframe: false,
            buttonDestination: 'cart',
            contents: {
              img: false,
              title: false,
              options: true,
              price: false,
              quantity: this.quantitySelector,
              quantityDecrement: true,
              quantityIncrement: true,
              quantityInput: true,
            },
            templates: {
              button:
                '<div class="button ' +
                (this.margins ? 'margins ' : '') +
                (this.primary ? 'primary ' : '') +
                '{{data.classes.product.button}} {{data.buttonClass}}">' +
                '{{data.buttonText}}' +
                '<span class="arrow"></span></div>',
              quantity: `<div class="{{data.classes.product.quantity}} {{data.quantityClass}}" data-element="product.quantity">
                {{#data.contents.quantityDecrement}}
                  <button class="button primary inverted {{data.classes.product.quantityButton}} {{data.classes.product.quantityDecrement}}" type="button" data-element="product.quantityDecrement"><span>-</span></button>
                {{/data.contents.quantityDecrement}}
                {{#data.contents.quantityInput}}
                  <input class="button primary inverted {{data.classes.product.quantityInput}}" type="number" min="0" aria-label="Quantity" value="{{data.selectedQuantity}}" data-element="product.quantityInput">
                {{/data.contents.quantityInput}}
                {{#data.contents.quantityIncrement}}
                  <button class="button primary inverted {{data.classes.product.quantityButton}} {{data.classes.product.quantityIncrement}}" type="button" data-element="product.quantityIncrement"><span>+</span></button>
                {{/data.contents.quantityIncrement}}
              </div>`
            },
            text: {
              button: 'Add to cart',
              outOfStock: 'Coming soon',
            },
          },
        },
      })
    },
  },
}
